var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"icon-style",attrs:{"icon":"circle-notch","size":"4x","spin":""}})}
var staticRenderFns = []

export { render, staticRenderFns }